const colors = {
  // Dark Colors
  Dark1000: "#111111",
  Dark800: "#414141",
  Dark600: "#707070",
  Dark400: "#A0A0A0",
  Dark200: "#CFCFCF",
  Dark100: "#E7E7E7",
  Dark50: "#F5F6F5",
  Dark25: "#F7F8F8",

  // Gray Colors
  Gray25: "#F7F8F8",
  Gray50: "#F5F6F5",
  Gray100: "#E7E7E7",
  Gray200: "#CFCFCF",
  Gray400: "#A0A0A0",

  // White Color
  White: "#FFFFFF",

  // Green Colors
  Green200: "#0B5C11",
  Green100: "#008B07",
  Green50: "#00E606",
  Green25: "#C2E6C4",
  GreenDarkMode: "#158362",
  WarmGreen100: "#D9DAD2",
  SecondaryMint: "#BAEDBD",

  // Red Colors
  Red200: "#CC3E3E",
  Red100: "#FF4D4E",
  Red50: "#FFB8B8",
  Red25: "#FFEDED",

  // Yellow Colors
  Yellow200: "#F3BC4E",
  Yellow100: "#FFD233",
  Yellow50: "#FAE4B8",
  Yellow25: "#FEF8ED",

  // Black Color
  Black: "#151617",
  Black100: "#1C1C1C",

  // Dark Mode Colors
  DarkMode100: "#1E2021",
  DarkMode50: "#2D2D2D",
  DarkMode25: "#5E5E5E",

  // old colors to be deleted
  gray25: "#F7F8F8",
  gray50: "#F5F6F5",
  gray100: "#E7E7E7",
  gray200: "#CFCFCF",
  gray400: "#A0A0A0",
  dark600: "#707070",
  dark800: "#414141",
  dark1000: "#111111",
  white: "#FFFFFF",
  black: "#000000",
  black80: "#1C1C1C80",
  black100: "#1C1C1C",
  greenSecondary: "#BAEDBD",
  green25: "#E7EFED",
  green50: "#9FBFB6",
  green100: "#106048",
  green200: "#0D4D3A",
  greenWarm100: "#D9DAD2",
  greenDarkMode: "#158362",
  tournamentColour: "#1EA5E0",
  tryoutColour: "#9747FF",
  red25: "#FFEDED",
  red50: "#FFB8B8",
  red100: "#FF4D4E",
  red200: "#CC3E3E",
  yellow25: "#FEF8ED",
  yellow50: "#FAE4B8",
  yellow100: "#FFD233",
  yellow200: "#F3BC4E",
  blueLight50: "#F0F9FF",
  blueLight700: "#026AA2",
};

const palette = {
  background: {
    default: colors.Gray25, // Default background color for the entire application
    secondary: colors.White,
  },
  primary: {
    main: colors.Green100, // Main color for primary elements like active links or primary buttons
    contrastText: colors.White, // Text color that contrasts with primary.main for readability
  },
  secondary: {
    main: colors.SecondaryMint, // Main color for secondary elements like inactive links or secondary buttons
    contrastText: colors.Green100, // Text color that contrasts with secondary.main for readability
  },
  error: {
    main: colors.Red200, // Color used to indicate error states or messages
    contrastText: colors.White, // Text color that contrasts with error.main for readability
  },
  warning: {
    main: colors.Yellow200, // Color used to indicate warning or cautionary states
    contrastText: colors.White, // Text color that contrasts with warning.main for readability
  },
  success: {
    main: colors.Green50, // Color used to indicate success or positive feedback
    contrastText: colors.White, // Text color that contrasts with success.main for readability
  },
};

export default palette;

export { colors };
